import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { FaceAuthContainer } = await import('@containers/BiometricAuthentication/FaceAuth/index');
    return {
        Component: FaceAuthContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
